import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators';
import {repeat} from 'lit/directives/repeat.js';
import {SubmenuItem} from './submenu-item';
import {containerStyles, normalizeStyles} from '@webs/components-library/theming';


@customElement('webs-navigation-submenu')
export class NavigationSubmenu extends LitElement {

  static styles = [
    normalizeStyles,
    containerStyles,
    css`
      .submenu {
        background: var(--color-light-grey);
        height: 100%;
        padding: 1.6rem 0 0;
      }

      webs-navigation-column {
        display: block;
      }

      webs-navigation-column:nth-child(n+2) {
        padding: 1.6rem 0 0;
      }

      @media only screen and (min-width: 1175px) {
        .submenu {
          background: var(--color-white);
          border-radius: 0px 0px 4px 4px;
          box-shadow: 0 0 1px rgba(24, 26, 35, 0.08),
                      0 6.7px 12px rgba(24, 26, 35, 0.08);
          padding-bottom: 2.9rem;
        }

        .submenu__wrapper {
          display: flex;
          flex-wrap: wrap;
          margin: 0 auto;
          max-width: calc(var(--container-width) + 2.3rem + 2.3rem);
        }

        webs-navigation-column,
        webs-navigation-column:nth-child(n+2) {
          padding: 1rem 2.3rem 0;
        }
      }
    `
  ];

  @property({type: Array})
  items: SubmenuItem[] = [
    {
      title: "Smart selling for B2B",
      items: [
        {
          title: 'About cleverbridge',
          link: 'https://www.cleverbridge.com'
        },
        {
          title: 'Newsroom',
          link: 'https://www.cleverbridge.com'
        },
        {
          title: 'Partners',
          link: 'https://www.cleverbridge.com',
          description: 'Subtitle about manage pillar'
        },
        {
          title: 'Careers',
          link: 'https://www.cleverbridge.com',
          tag: 'We’re hiring'
        },
        {
          title: 'Contact',
          link: 'https://www.cleverbridge.com'
        }
      ]
    },
    {
      title: 'Optimize recurring revenue',
      items: [
        {
          title: 'About cleverbridge',
          link: 'https://www.cleverbridge.com'
        },
        {
          title: 'Newsroom',
          link: 'https://www.cleverbridge.com'
        },
        {
          title: 'Partners',
          link: 'https://www.cleverbridge.com',
          description: 'Subtitle about manage pillar'
        },
        {
          title: 'Careers',
          link: 'https://www.cleverbridge.com',
          tag: 'We’re hiring'
        },
        {
          title: 'Contact',
          link: 'https://www.cleverbridge.com'
        }
      ]
    }
  ];

  protected render(): unknown {
    return html`
      ${this.items && this.items.length > 0 ? html`
        <div class="submenu">
          <div class="submenu__wrapper">
            ${repeat(this.items, (item, index) => html`
              <webs-navigation-column title="${item.title}" .items='${item.items}'></webs-navigation-column>
            `)}
          </div>
        </div>
      ` : ''}
    `;
  }
}
